import { FC } from 'react';

import { DiscountEntry } from '@telialt/common-order-cart/src/entries/DiscountEntry';
import { useLogErrorEshop } from '@telialt/utils/src/datadog/useLogError';
import { selectAppliedVoucher } from '@telialt/utils/src/eshopSelectors';

import { useSubmitCouponMutation } from '../../hooks/mutations/useSubmitCouponMutation';
import { useCartQuery } from '../../hooks/queries/useCartQuery';

export const DiscountEntryConnected: FC = () => {
    const { cart } = useCartQuery();
    const voucher = selectAppliedVoucher(cart);

    const { submitCouponCode, submitCouponCodeIsLoading, submitCouponCodeError } = useSubmitCouponMutation();
    useLogErrorEshop(submitCouponCodeError);

    return (
        <DiscountEntry
            voucherCode={voucher?.code}
            onSubmitCode={submitCouponCode}
            isLoading={submitCouponCodeIsLoading}
            isInvalid={Boolean(submitCouponCodeError)}
        />
    );
};
